import { render, staticRenderFns } from "./captcha.vue?vue&type=template&id=cd94e8f4&scoped=true&"
import script from "./captcha.vue?vue&type=script&lang=js&"
export * from "./captcha.vue?vue&type=script&lang=js&"
import style0 from "./captcha.vue?vue&type=style&index=0&id=cd94e8f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd94e8f4",
  null
  
)

export default component.exports